import { useQuery } from '@provision/graphql-client';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { GET_WORKFLOWS_QUERY } from 'src/graphql/entities/workflow/workflow.operations';
import { GetWorkflowsQuery } from 'src/graphql/entities/workflow/workflow.types';
import { QueryVariables } from 'src/graphql/types';
import { useNotifications } from 'src/utils/hooks';

export const useWorkflows = (partnerId?: number | null) => {
  const { showErrorAlert } = useNotifications();

  const {
    data,
    loading,
    error,
    refetch: refetchWorkflows,
  } = useQuery<GetWorkflowsQuery, QueryVariables>(GET_WORKFLOWS_QUERY, {
    variables: isNullish(partnerId)
      ? undefined
      : {
          params: {
            filters: [
              {
                attribute: 'partnerId',
                operator: '=',
                value: partnerId.toString(),
              },
            ],
            sorting: [{ attribute: 'name' }],
          },
        },
    skip: isNullish(partnerId),
    onError: (fetchError) => {
      console.error(fetchError);
      showErrorAlert('Failed to load workflows. Please try again.');
    },
  });

  const workflows = useMemo(
    () => data?.getWorkflow?.records ?? [],
    [data?.getWorkflow?.records],
  );

  return {
    workflows,
    loading,
    error,
    refetchWorkflows,
  };
};
